
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const AlmadaaDigital = lazy(() => import('../pages/almadaa-digital/page'));
const DennywiseTravel = lazy(() => import('../pages/dennywise-travel/page'));
const Goals = lazy(() => import('../pages/goals/page'));
const WhyChooseUs = lazy(() => import('../pages/why-choose-us/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const AffiliateProgram = lazy(() => import('../pages/affiliate-program/page'));
const ArkCareFoundation = lazy(() => import('../pages/ark-care-foundation/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/almadaa-digital',
    element: <AlmadaaDigital />
  },
  {
    path: '/dennywise-travel',
    element: <DennywiseTravel />
  },
  {
    path: '/goals',
    element: <Goals />
  },
  {
    path: '/why-choose-us',
    element: <WhyChooseUs />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/affiliate-program',
    element: <AffiliateProgram />
  },
  {
    path: '/ark-care-foundation',
    element: <ArkCareFoundation />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
